import React, { useEffect, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/index.scss';
import Industry from './industry';
import Time from './time';
import ChangeRate from './change-rate';
import CapitalAnalysis from './capital-analysis';
import StaffSize from './staff-size';
import OutputTop10 from './output-top10';
import HuringRevenue from './huring-revenue';
import DataModel from './component/data-model';
import URI from 'urijs';


interface IProps { }
interface IState { }

const HumanResource = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const uri = new URI(window.location.href);
  const path: any = uri.query(true);
  const result: any = decodeURIComponent(path.check);
  const data = JSON.parse(result);

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="effect-industry-contrast-warp">
      {(data.tabList?.a1 || data.tabList?.a2 || data.tabList?.a3 || data.tabList?.a4 || data.tabList?.a5 || data.tabList?.a6) && <Industry />}
      {(data.tabList?.b1 || data.tabList?.b2 || data.tabList?.b3 || data.tabList?.b4 || data.tabList?.b5 || data.tabList?.b6) && <Time />}
      {(data.tabList?.c1 || data.tabList?.c2 || data.tabList?.c3) && <ChangeRate />}
      {(data.tabList?.d1 || data.tabList?.d2 || data.tabList?.d3 || data.tabList?.d4) && <CapitalAnalysis />}
      {(data.tabList?.e1 || data.tabList?.e2) && <StaffSize />}
      {(data.tabList?.f1 || data.tabList?.f2 || data.tabList?.f3 || data.tabList?.f4 || data.tabList?.f5 || data.tabList?.f6) && <OutputTop10 />}
      {data.tabList?.g && <HuringRevenue />}
    </section>
  );
};

export default observer(HumanResource);
